export default {
  'brandListing.all': 'Todos',
  'brandListing.byCategories': 'Por categorías',
  'brandListing.clear': 'Borrar',
  'brandListing.productsAndServices': 'Productos y servicios',
  'brandListing.seeProductsFor': 'Ver productos de',
  'brandListing.similarBrands': 'Marcas con productos y servicios similares',
  'brandListing.visitWebsite': 'Ir al sitio web',
  'cards.advice.link': 'Leer el artículo',
  'cards.category.link': 'Leer más',
  'cards.event.link': 'Ver evento',
  'cards.news.link': 'Seguir leyendo',
  'cards.product.link': 'Ver más',
  'footer.copyright': '© {year} Arvesta. Todos los derechos reservados.',
  'footer.newsletter.error': 'Se ha producido un error con la información que ha introducido. Inténtelo de nuevo.',
  'footer.newsletter.heading':
    '¿Le gustaría recibir noticias y consejos sobre lo que le interesa? ¡Se los enviaremos encantadamente!',
  'footer.newsletter.placeholder': 'Escriba su dirección de correo electrónico',
  'footer.newsletter.subscribe': 'Apuntarme',
  'footer.newsletter.success': 'Ya está suscrito. ¡Gracias! Pronto tendrá noticias nuestras.',
  'footer.subscribe.enteremail': 'Escriba su dirección de correo electrónico',
  'footer.subscribe.failure': 'Se ha producido un error con la información que ha introducido. Inténtelo de nuevo.',
  'footer.subscribe.invalid_email': 'Correo electrónico no válido',
  'footer.subscribe.subscribe': 'Apuntarme',
  'footer.subscribe.subscribing': 'Registro en curso',
  'footer.subscribe.success': 'Ya está suscrito. ¡Gracias! Pronto tendrá noticias nuestras.',
  'forms.contact.description': 'Rellene el siguiente formulario y nuestro equipo se pondrá en contacto con usted.',
  'forms.contact.email.label': 'Dirección de correo electrónico',
  'forms.contact.email.placeholder': 'Escriba su dirección de correo electrónico',
  'forms.contact.errors.email': 'Correo electrónico no válido',
  'forms.contact.errors.required': 'Campo obligatorio',
  'forms.contact.failure': 'Se ha producido un error con la información que ha introducido. Inténtelo de nuevo.',
  'forms.contact.fullname.label': 'Nombre completo',
  'forms.contact.fullname.placeholder': 'Escriba su nombre completo.',
  'forms.contact.message.label': 'Mensaje',
  'forms.contact.message.placeholder': 'Escriba su mensaje',
  'forms.contact.newsletter.title':
    '¿Quiere recibir correos electrónicos con noticias, actualizaciones de productos e información sobre eventos? Podrá apuntarse más adelante.',
  'forms.contact.submit': 'Enviar',
  'forms.contact.success': 'Gracias, ya estamos estudiando su mensaje.',
  'forms.contact.title': 'Envíenos un mensaje',
  'globals.download': 'Descargar',
  'globals.featuredProducts': 'Productos destacados',
  'globals.no': 'No',
  'globals.yes': 'Sí',
  'header.search.placeholder': 'Buscararch',
  'header.selectlanguage': 'Seleccionar idioma',
  'legacy.cookie.description': 'Si continúa navegando por el sitio, usted acepta el uso que hacemos de',
  'legacy.footer.headoffice': 'Oficina central',
  'legacy.footer.headquarters': 'Sede',
  'legacy.header.about': 'sobre',
  'legacy.header.contact': 'contacto',
  'legacy.header.jobs': 'vacantes',
  'legacy.header.news': 'noticias y prensa',
  'legacy.header.products': 'productos y servicios',
  'newsletter.email.error': 'Por favor, introduce una dirección de correo electrónico válida.',
  'newsletter.email.success': 'Te suscribiste con éxito. En breve tendrá noticias nuestras.',
  'newsletter.input.placeholder': 'E-mailadress',
  'newsletter.terms.error': 'Por favor acepta las condiciones generales de privacidad',
  'newsletter.terms.privacyPolicy': 'política de privacidad',
  'newsletter.terms.sectionOne': 'estoy de acuerdo con el',
  'newsletter.terms.sectionTwo': 'de Proxani',
  'newsletter.terms.subscribe': 'Suscribir',
  'product.certifications.title': 'Certificaciones de productos',
  'sections.advice.loadmore': 'Cargar más consejos',
  'sections.category.loadmore': 'Cargar más categorías',
  'sections.contact.offices': 'Oficinas',
  'sections.contact.openinghours': 'Horario de apertura',
  'sections.contact.salesteam': 'Equipo',
  'sections.contact.viewonmap': 'Ver en el mapa',
  'sections.dealer.clear': 'BORRAR',
  'sections.dealer.invalidaddress': 'No se pudo encontrar la dirección',
  'sections.dealer.loadmore': 'Ver todos los distribuidores',
  'sections.dealer.maplink': 'Ver en el mapa',
  'sections.dealer.placeholder': 'Introduzca su código postal y localidad',
  'sections.dealer.search': 'Buscar',
  'sections.dealer.total': '{total} Resultados de "{query}"',
  'sections.events.loadmore': 'Cargar más eventos',
  'sections.events.loadmorepast': 'Cargar más eventos finalizados',
  'sections.news.loadmore': 'Cargar más noticias',
  'sections.product.loadmore': 'Cargar más',
  'sections.product.noproductsfoundfor': 'No se han encontrado productos para',
  'sections.product.table.brochure': 'FOLLETO',
  'sections.product.table.download': 'Descargar',
  'sections.product.table.number': 'N.º DE ART.',
  'sections.product.table.product': 'PRODUCTO',
  'sections.product.table.weight': 'PESO',
  'sections.search.events': 'Eventos',
  'sections.search.news': 'Noticias',
  'sections.search.noncategorised': 'No categorizados',
  'sections.search.noresults.title': 'Lo sentimos, no hemos encontrado ningún resultado para ',
  'sections.search.products': 'Productos',
  'sections.search.results.title': '{total} Resultados de "{query}"',
  'sections.search.seeallevents': 'Ver todos los eventos',
  'sections.search.seeallnews': 'Ver todas las noticias',
  'sections.search.seeallproducts': 'Ver todos los productos',
};
